export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "worker.ea2947f0172e7b4ba82a.worker.js");
}
